export default __webpack_public_path__ + "static/media/AFlightToNYC_04.076bf0ef.png";